import { EllipsisVerticalIcon } from '@heroicons/react/24/outline';
import { Pencil01Icon, Trash01Icon } from '@langchain/untitled-ui-icons';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/Dropdown';
import { TableCellTextOverflow } from '@/components/Table';
import { ExampleSchema } from '@/types/schema';

import { COLUMNS_DEF as COLUMNS_DEF_CONSTANT } from '../constants/columnsDef';

const columnHelper = createColumnHelper<ExampleSchema>();

// Re-export for backward compatibility - PublicExampleTable still uses it
export const COLUMNS_DEF = COLUMNS_DEF_CONSTANT;

export const getActionColumn = (
  isReadOnly?: boolean
): ColumnDef<ExampleSchema, any> => {
  return columnHelper.display({
    id: 'actions',
    cell: ({ row, table }) => {
      const { actions } = (table.options.meta ?? {}) as {
        actions: {
          handleDelete: (id: string) => void;
          handleEdit: (example: ExampleSchema) => void;
        };
      };

      return (
        <TableCellTextOverflow className="justify-end">
          <DropdownMenu>
            <DropdownMenuTrigger
              onClick={(e) => e.stopPropagation()}
              className="flex h-6 w-6 items-center justify-center rounded-md transition-colors hover:bg-secondary focus:outline-none"
            >
              <EllipsisVerticalIcon className="h-5 w-5" />
            </DropdownMenuTrigger>

            <DropdownMenuContent
              className="z-10"
              onClick={(e) => e.stopPropagation()}
            >
              <DropdownMenuItem
                onClick={() => actions.handleEdit(row.original)}
                className="flex items-center gap-2"
                disabled={isReadOnly}
              >
                <Pencil01Icon className="h-5 w-5" />
                Edit
              </DropdownMenuItem>
              <DropdownMenuItem
                onClick={() => actions.handleDelete(row.original.id)}
                className="flex items-center gap-2"
                disabled={isReadOnly}
              >
                <Trash01Icon className="h-5 w-5" />
                Delete
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </TableCellTextOverflow>
      );
    },
    enableSorting: false,
    enableHiding: false,
    enableResizing: false,
    size: 40,
  });
};
